<header class="flex items-center gap-3 sm:gap-4 px-4 sm:px-6 py-3 sm:py-4 bg-white border-b border-gray-200 shrink-0">
  @if (isAuthenticated$ | async) {
    <button
      type="button"
      (click)="onBackClick()"
      class="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-900 transition-colors cursor-pointer"
      aria-label="Go back to dashboard"
    >
      <lucide-icon [img]="icons.ArrowLeft" class="w-4 h-4 sm:w-5 sm:h-5"></lucide-icon>
    </button>
  }

  <div class="flex items-center gap-3 flex-1">
    <div>
      <h1 class="text-base sm:text-lg font-semibold text-gray-900">Grading Assistant</h1>
      <p class="hidden sm:block text-xs sm:text-sm text-gray-500">AI-powered grading help</p>
    </div>
  </div>

  <app-grading-badge></app-grading-badge>
</header>
